import { sendHttpRequest } from "lib/fetcher";

export function createAppSecret(appName) {
  return sendHttpRequest({
    url: "/third/app_secrets",
    method: "POST",
    data: { openapi: { clientName: appName } },
  });
}
export function getAppSecrets() {
  return sendHttpRequest({
    url: "/third/app_secrets",
    method: "GET",
  });
}
export function deleteAppSecret(clientId) {
  return sendHttpRequest({
    url: `/third/app_secrets/${clientId}`,
    method: "DELETE",
  });
}
export function createWebHook(endpoint) {
  return sendHttpRequest({
    url: "/third/webhooks",
    method: "POST",
    data: { webhook: { endpoint } },
  });
}
export function getWebHook() {
  return sendHttpRequest({
    url: "/third/webhooks",
    method: "GET",
  });
}
export function deleteWebHook(clientId) {
  return sendHttpRequest({
    url: `/third/webhooks/${clientId}`,
    method: "DELETE",
  });
}
